module.exports = __webpack_public_path__ + "img/logo-dark.a95355c1.png";